import cx from 'classnames';

import uploadSvg from 'assets/icons/upload.svg';
import { ButtonThemes, SectionButtonTheme } from 'lib/SectionButton/SectionButton.types';
import Button, { Color, Size } from 'lib/Button';
import IconButton from 'lib/IconButton';

const DisplayCustomFileUpload = ({
  theme,
  isFileIconVisibleOnly,
  open,
  isEffectiveDisabled,
  maxFileUploads,
}: {
  open: () => void;
  theme: SectionButtonTheme;
  isFileIconVisibleOnly: boolean | undefined;
  isEffectiveDisabled: boolean;
  maxFileUploads: number | undefined;
}): React.ReactElement => {
  if (isFileIconVisibleOnly) {
    return (
      <IconButton
        name="file-upload"
        icon={uploadSvg}
        handleOnClick={open}
        isDisabled={isEffectiveDisabled}
        dataTestId="file-upload-icon"
      />
    );
  }

  return (
    <Button
      dataTestId="file-upload-button"
      color={Color.TRANSPARENT}
      size={Size.MEDIUM}
      isDisabled={isEffectiveDisabled}
      svg={uploadSvg}
      svgClassnames={cx({
        'text-neutral-500': isEffectiveDisabled,
        [ButtonThemes[theme].iconColor]: !isEffectiveDisabled,
      })}
      label={`Upload files${maxFileUploads ? ` (${maxFileUploads} maximum)` : ''}`}
      classNames={cx('sub-header-base border w-full !justify-start', {
        [ButtonThemes[theme].inactive]: true,
        [ButtonThemes[theme].buttonContainer]: !isEffectiveDisabled,
        [ButtonThemes[theme].disabled]: isEffectiveDisabled,
      })}
    />
  );
};

export default DisplayCustomFileUpload;
